import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { isUndefined } from 'lodash';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';

@Component({
  selector: 'app-premium-icon',
  templateUrl: './premium-icon.component.html',
  styleUrls: ['./premium-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumIconComponent implements OnInit {
  @Input() iconSize: IconSizesEnum;
  @Input() altDesign: boolean;

  icon: IIcon;

  constructor() {}

  ngOnInit() {
    this.icon = {
      name: this.altDesign ? 'premium-feature-alt' : 'premium-feature',
      size: isUndefined(this.iconSize) ? IconSizesEnum.medium : this.iconSize,
      customClass: 'premium-icon',
    };
  }
}
